import React from 'react';

import { getTrans } from '@/utils/tools';
import { TRACKING_TYPE, VideoTransifyKey } from '@/utils/constants';
import { VideoShowStatus } from '@/types/components/Video';
import { playVideo } from '@/utils/videoTools';
import { trackingHandler } from '@/utils/btnClickHandler';

import PlayVideo from '@/assets/img/play_video.svg';
import VideoLoading from '@/assets/img/video_loading.svg';
import VideoFailed from '@/assets/img/video_failed.svg';
import * as Toast from '@/utils/Toast';
// import moment from 'moment';
import dateLib from '@/utils/dateLib/moment';
import clsx from 'classnames';

export interface VideoControlProps {
  duration: number;
  /** 用于展示的status */
  status: VideoShowStatus;
  isHistory: boolean;
  videoPath?: string;
  messageId?: string;
  loyaltyTierCode?: number;
  getThumbnailError?: boolean;
}

const VideoControl = (props: VideoControlProps) => {
  const handleLoadingClick = () => {
    Toast.error(getTrans(VideoTransifyKey.VideoUploadingPrompt));
  };

  const handlePlayClick = () => {
    if (!props.isHistory) {
      trackingHandler({
        trackingname: TRACKING_TYPE.VIDEO_PLAY_BUTTON,
        trackingdata: {
          client_rank: props.loyaltyTierCode?.toString(),
          video_original_duration: props.duration,
          message_id: props.messageId,
        },
      });
    }

    playVideo(props.videoPath!);
  };

  switch (props.status) {
    /** 展示loading */
    case VideoShowStatus.Uploading:
      return (
        <div className="video-control" onClick={handleLoadingClick}>
          <img className="video-loading" src={VideoLoading} />
          <div>{getTrans(VideoTransifyKey.VideoStatusUploading)}</div>
        </div>
      );

    /** 展示播放 */
    case VideoShowStatus.Play:
      // const formatDuration = moment(props.duration).toObject();
      // const formatDuration = dateLib.toObject(props.duration);
      const formatDuration = dateLib.getDuration(Math.floor(props.duration / 1000));

      return (
        <div className="video-control" onClick={handlePlayClick}>
          <img className="video-play" src={PlayVideo} />
          <div className={clsx('video-duration', { 'error': props.getThumbnailError })}>
            {formatDuration[2]}:{formatDuration[3].toString().padStart(2, '0')}
          </div>
        </div>
      );

    /** 展示失败 */
    case VideoShowStatus.Failed:
      return (
        <div className="video-control">
          <img className="video-failed" src={VideoFailed} />
          <div>{getTrans(VideoTransifyKey.VideoStatusFailed)}</div>
        </div>
      );

    default:
      return null;
  }
};

export default VideoControl;
